import React from 'react';
import { Steps } from 'antd';

export const RBHSteps = (p: any) => {
  return (
      <Steps style={p.style} {...p} >
        {p.children}
      </Steps>
  );
};

export default RBHSteps;
